import { Injector, Pipe, PipeTransform } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import * as _ from 'lodash';

@Pipe({
    name: 'getData', pure: false
})
export class GetDataPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {
    }

    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }

    //transform(text: string): string {
    //    var parser = new DOMParser();
    //    var htmlDoc = parser.parseFromString(text, 'text/html');

    //    let aa = htmlDoc.getElementsByTagName("span");
    //    _.map(aa,
    //        (a) => {
    //            let data = {name: a.innerText}
    //            a.setAttribute('dtsSelectItem', `{{${data}}}`);
    //        });

    //    console.log(aa);
    //    let tmpText = text;

    //    return tmpText;
    //}

}
